import React, { FC } from 'react'

import './ErrorMessage.scss'

interface ErrorMessageProps {
  text: string
}
const ErrorMessage: FC<ErrorMessageProps> = ({ text }) => {
  return (
    <div className='error-message'>
      <div className='error-message__text'>{text}</div>
    </div>
  )
}

export default ErrorMessage
